import { Component } from '@angular/core';
import { CommonService } from 'wire-frame';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  constructor(private route: ActivatedRoute, private common: CommonService) {
    const res = this.common.getLoggedInUser();
    if (res?.type === 'doctor') {
      this.common.redirect('/admin/prescriptions');
    }
    else if (res?.type === 'reception') {
      // this.common.redirect('/admin/appointment');
      this.common.redirect('/admin/reception-dues');
    }
    else if (res?.type === 'pharmacy') {
      this.common.redirect('/admin/pharmacy');
    }
    else if (res?.type === 'assistant_doctor') {
      this.common.redirect('/admin/pre-consultation');
    }
  }
}
